import { html, TemplateResult } from 'lit';
import { msg } from '@lit/localize';

/**
 * Render slider control buttons with preview images
 * @param prevSlidePreviewUrl - URL of the previous slide preview image
 * @param nextSlidePreviewUrl - URL of the next slide preview image
 * @param onPrevClick - Handler for previous button click
 * @param onNextClick - Handler for next button click
 * @param onKeyDown - Handler for keyboard events
 * @returns Lit template result with control buttons
 */
export const renderSliderControls = (
    prevSlidePreviewUrl: string,
    nextSlidePreviewUrl: string,
    onPrevClick: () => void,
    onNextClick: () => void,
    onKeyDown: (event: KeyboardEvent, handler: () => void) => void
): TemplateResult => html`
    <div class="swiper-buttons-container">
        <div
            class="control-button control-prev"
            @click=${onPrevClick}
            @keydown=${(e: KeyboardEvent) => onKeyDown(e, onPrevClick)}
        >
            <der-ui-controls
                direction="left"
                ariaLabel="${msg('Vorheriger slide', { desc: 'Aria label for the previous slide button' })}"
            ></der-ui-controls>
        </div>

        <div class="preview-images">
            <div class="preview-image prev-preview">
                <img src="${prevSlidePreviewUrl}" alt="" />
            </div>
            <div class="preview-image next-preview">
                <img src="${nextSlidePreviewUrl}" alt="" />
            </div>
        </div>

        <div
            class="control-button control-next"
            @click=${onNextClick}
            @keydown=${(e: KeyboardEvent) => onKeyDown(e, onNextClick)}
        >
            <der-ui-controls
                direction="right"
                ariaLabel="${msg('Nächster slide', { desc: 'Aria label for the next slide button' })}"
            ></der-ui-controls>
        </div>
    </div>
`;
